// Utils
import { isCommentThread } from '../../../common/elements/utils/elementTypeUtils';

// Constants
import { ACCESS_BITS } from '../../../common/permissions/permissionConstants';

const feedbackRequired = () => ACCESS_BITS.FEEDBACK;
const commentsFeedbackOtherwiseAll = (selectedElements) =>
    selectedElements.every(isCommentThread) ? ACCESS_BITS.FEEDBACK : ACCESS_BITS.WRITE;

export const TOOLBAR_MODES = {
    ELEMENTS: 'ELEMENTS',
    SELECT: 'SELECT',
};

export const TOOLS = {
    ELEMENT_FEATURES: { id: 'ELEMENT_FEATURES', name: 'Features', multiSelect: true },
    RICH_TEXT: { id: 'RICH_TEXT', name: null, multiSelect: false },
    TASK_RICH_TEXT: { id: 'TASK_RICH_TEXT', name: null, multiSelect: false },
    TASK_COLOR: { id: 'TASK_COLOR', name: 'Color', multiSelect: false },
    ICON: { id: 'ICON', name: 'Icon', multiSelect: false },
    CAPTION: { id: 'CAPTION', name: 'Caption', multiSelect: true },

    MEDIA: { id: 'MEDIA', name: 'Media', multiSelect: true },
    MEDIA_LOOP: { id: 'MEDIA_LOOP', name: 'Loop', multiSelect: true },
    MEDIA_AUTOPLAY: { id: 'MEDIA_AUTOPLAY', name: 'Autoplay', multiSelect: true },

    LOCK: { id: 'LOCK', name: 'Lock position', multiSelect: true },
    SHOW_BACKGROUND: { id: 'SHOW_BACKGROUND', name: 'Transparent', multiSelect: true },
    ALIGNMENT: { id: 'ALIGNMENT', name: 'Align', multiSelect: true },
    CONNECT_WITH_LINES: { id: 'CONNECT_WITH_LINES', name: 'Connect', multiSelect: true },
    DISCONNECT_LINES: { id: 'DISCONNECT_LINES', name: 'Disconnect', multiSelect: true },
    DISTRIBUTE: { id: 'DISTRIBUTE', name: 'Distribute', multiSelect: true },
    TITLE: { id: 'TITLE', name: 'Title', multiSelect: true },
    ASSIGNMENT: { id: 'ASSIGNMENT', name: null, multiSelect: false },
    IMAGE_EDIT: { id: 'IMAGE_EDIT', name: 'Edit image', multiSelect: false },
    REACTION: { id: 'REACTION', name: 'Add reaction', multiSelect: true, permissionRequired: feedbackRequired },

    DISPLAY_MODE: { id: 'DISPLAY_MODE', name: 'Preview', multiSelect: true },

    // COLOR
    COLOR: { id: 'COLOR', name: 'Color', multiSelect: true, permissionRequired: commentsFeedbackOtherwiseAll },
    CUSTOM_COLOR: { id: 'CUSTOM_COLOR', name: 'Color', multiSelect: true },
    COLOR_DISPLAY: { id: 'COLOR_DISPLAY', name: 'Display', multiSelect: true },

    // LINE
    START_ARROW: { id: 'START_ARROW', name: 'Start', multiSelect: true },
    END_ARROW: { id: 'END_ARROW', name: 'End', multiSelect: true },
    LINE_STYLE: { id: 'LINE_STYLE', name: 'Dashed', multiSelect: true },
    LINE_WEIGHT: { id: 'LINE_WEIGHT', name: 'Weight', multiSelect: true },
    LINE_LABEL: { id: 'LINE_LABEL', name: 'Label', multiSelect: false },

    // Comment
    COLLAPSE: { id: 'COLLAPSE', name: 'Collapse', multiSelect: true, permissionRequired: feedbackRequired },

    // Drawing
    EDIT_DRAWING: { id: 'EDIT_DRAWING', name: 'Edit drawing', multiSelect: false },

    // Tables
    TABLE_OPERATIONS: { id: 'TABLE_OPERATIONS', name: null, multiSelect: false },
};

export const TOOLBAR_SIZE_BREAKPOINTS = {
    SMALL: 680,
};
